(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class OptimizedHeaderController {
    constructor() {
      this.header = document.querySelector('[data-header]');
      this.spacer = document.querySelector('.header-spacer');

      if (!this.header) return;

      this.config = {
        stickyType: this.header.dataset.stickyType || 'none',
        scrollThreshold: 10,
        mobileBreakpoint: 990,
        debounceDelay: 16, // ~60fps
      };

      this.state = {
        isSticky: false,
        isAnimated: false,
        lastScrollY: 0,
        headerHeight: 0,
        announcementHeight: 0,
        totalHeight: 0,
        isUpdating: false, // Prevent double updates
      };

      this.handleScroll = this.debounce(this.onScroll.bind(this), this.config.debounceDelay);
      this.handleResize = this.debounce(this.onResize.bind(this), 200);

      this.init();
    }

    init() {
      this.calculateDimensions();
      this.setupEventListeners();
      this.setupObservers();
      this.updateHeaderState(window.scrollY);
    }

    calculateDimensions() {
      // Get announcement bar height dynamically
      const announcementBar = document.querySelector('.announcement-bar');
      this.state.announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

      // Get header height
      this.state.headerHeight = this.header.offsetHeight;

      // Calculate total height for spacer
      this.state.totalHeight = this.state.headerHeight;

      // Update CSS custom properties
      this.updateCSSProperties();

      // Notify search panel about header changes
      this.notifyHeaderChange();
    }

    updateCSSProperties() {
      const root = document.documentElement;

      root.style.setProperty('--header-height', `${this.state.headerHeight}px`);
      root.style.setProperty('--announcement-bar-height', `${this.state.announcementHeight}px`);

      if (this.state.isSticky && this.config.stickyType === 'always') {
        this.header.style.top = `${this.state.announcementHeight}px`;
      }
    }

    setupObservers() {
      if (window.ResizeObserver) {
        this.headerObserver = new ResizeObserver(() => {
          if (!this.state.isUpdating) {
            this.state.isUpdating = true;
            requestAnimationFrame(() => {
              this.calculateDimensions();
              this.updateSpacerHeight();
              this.state.isUpdating = false;
            });
          }
        });
        this.headerObserver.observe(this.header);

        const announcementBar = document.querySelector('.announcement-bar');
        if (announcementBar) {
          this.announcementObserver = new ResizeObserver(() => {
            const newHeight = announcementBar.offsetHeight;
            if (newHeight !== this.state.announcementHeight) {
              this.state.announcementHeight = newHeight;
              this.updateCSSProperties();
              this.updateSpacerHeight();
            }
          });
          this.announcementObserver.observe(announcementBar);
        }
      }
    }

    setupEventListeners() {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.calculateDimensions();
          this.updateHeaderState(window.scrollY);
        });
      }
    }

    onScroll() {
      const scrollY = window.scrollY;
      this.updateHeaderState(scrollY);
      this.state.lastScrollY = scrollY;
    }

    onResize() {
      this.calculateDimensions();
      this.updateHeaderState(window.scrollY);
    }

    updateHeaderState(scrollY) {
      if (document.body.classList.contains('mobile-menu-open')) return;

      const shouldBeSticky = this.shouldHeaderBeSticky(scrollY);
      const shouldBeAnimated = this.shouldLogoBeAnimated(scrollY);

      if (shouldBeSticky !== this.state.isSticky) {
        this.toggleStickyState(shouldBeSticky);
      }

      if (shouldBeAnimated !== this.state.isAnimated) {
        this.toggleAnimationState(shouldBeAnimated);
      }
    }

    shouldHeaderBeSticky(scrollY) {
      if (this.config.stickyType !== 'always') return false;

      const roundedScrollY = Math.round(scrollY);

      if (this.state.isSticky) {
        return roundedScrollY > 5;
      } else {
        return scrollY > this.config.scrollThreshold;
      }
    }

    shouldLogoBeAnimated(scrollY) {
      const isMobile = window.innerWidth < this.config.mobileBreakpoint;
      return scrollY > this.config.scrollThreshold && !isMobile;
    }

    toggleStickyState(shouldBeSticky) {
      requestAnimationFrame(() => {
        this.updateSpacerHeight(shouldBeSticky);

        requestAnimationFrame(() => {
          if (shouldBeSticky) {
            this.header.classList.add('header--sticky');
          } else {
            this.header.classList.remove('header--sticky');
          }

          this.state.isSticky = shouldBeSticky;
        });
      });
    }

    toggleAnimationState(shouldBeAnimated) {
      requestAnimationFrame(() => {
        if (shouldBeAnimated) {
          this.header.classList.add('header__logo--animated');
        } else {
          this.header.classList.remove('header__logo--animated');
        }

        this.state.isAnimated = shouldBeAnimated;

        setTimeout(() => {
          this.calculateDimensions();
          this.updateSpacerHeight();
          this.notifyHeaderChange();
        }, 300);
      });
    }

    notifyHeaderChange() {
      const event = new CustomEvent('header:updated', {
        detail: {
          headerHeight: this.state.headerHeight,
          announcementHeight: this.state.announcementHeight,
          totalHeight: this.state.totalHeight,
          isSticky: this.state.isSticky,
          isAnimated: this.state.isAnimated,
        },
      });
      document.dispatchEvent(event);

      if (window.searchPanel) {
        window.searchPanel.refreshPosition();
      }
    }

    updateSpacerHeight(willBeSticky = null) {
      if (!this.spacer) return;

      const isSticky = willBeSticky !== null ? willBeSticky : this.state.isSticky;
      const spacerHeight = isSticky ? this.state.totalHeight : 0;

      requestAnimationFrame(() => {
        this.spacer.style.height = `${spacerHeight}px`;
      });
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.headerObserver) {
        this.headerObserver.disconnect();
      }

      if (this.announcementObserver) {
        this.announcementObserver.disconnect();
      }
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    window.headerController = new OptimizedHeaderController();
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (window.headerController) {
      window.headerController.destroy();
    }
  });

  /**
   * Breadcrumb Navigation Tracker
   * Captura los clicks en los links del menú y guarda la información del breadcrumb
   */
  class BreadcrumbTracker {
    constructor() {
      this.storageKey = 'breadcrumb_navigation_path';
      this.init();
    }

    init() {
      // Esperar a que el DOM esté listo
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupClickListeners());
      } else {
        this.setupClickListeners();
      }
    }

    setupClickListeners() {
      // Usar delegación de eventos para capturar clicks en todos los links del menú
      // Esto funciona incluso si el menú se carga dinámicamente
      document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-menu-level]');
        if (link) {
          this.saveBreadcrumbPath(link);
          return;
        }

        // Al salir del PDP por el breadcrumb (colección, Shop All, etc.), limpiar ruta guardada
        const breadcrumbLink = e.target.closest(
          '.breadcrumbs .breadcrumbs__link:not(.breadcrumbs__link--current)'
        );
        if (breadcrumbLink) {
          BreadcrumbTracker.clearSavedBreadcrumb();
        }
      }, { capture: true });
    }

    saveBreadcrumbPath(linkElement) {
      const level = linkElement.dataset.menuLevel;
      const breadcrumbData = {
        level: level,
        title: linkElement.dataset.menuTitle || linkElement.textContent.trim(),
        url: linkElement.dataset.menuUrl || linkElement.href,
        handle: linkElement.dataset.menuHandle || null,
        timestamp: Date.now()
      };

      // Construir la ruta completa según el nivel
      if (level === 'parent') {
        // Nivel 1: Solo el parent (ej: Shop All)
        breadcrumbData.path = [
          {
            title: breadcrumbData.title,
            url: breadcrumbData.url,
            level: 'parent'
          }
        ];
      } else if (level === 'child') {
        // Nivel 2: Parent > Child
        const parentTitle = linkElement.dataset.menuParentTitle || null;
        const parentUrl = linkElement.dataset.menuParentUrl || null;
        
        breadcrumbData.path = [];
        if (parentTitle && parentUrl) {
          breadcrumbData.path.push({
            title: parentTitle,
            url: parentUrl,
            level: 'parent'
          });
        }
        breadcrumbData.path.push({
          title: breadcrumbData.title,
          url: breadcrumbData.url,
          level: 'child'
        });
      } else if (level === 'grandchild') {
        // Nivel 3: Parent > Child > Grandchild
        const parentTitle = linkElement.dataset.menuParentTitle || null;
        const parentUrl = linkElement.dataset.menuParentUrl || null;
        const childTitle = linkElement.dataset.menuChildTitle || null;
        const childUrl = linkElement.dataset.menuChildUrl || null;
        
        breadcrumbData.path = [];
        if (parentTitle && parentUrl) {
          breadcrumbData.path.push({
            title: parentTitle,
            url: parentUrl,
            level: 'parent'
          });
        }
        if (childTitle && childUrl) {
          breadcrumbData.path.push({
            title: childTitle,
            url: childUrl,
            level: 'child'
          });
        }
        breadcrumbData.path.push({
          title: breadcrumbData.title,
          url: breadcrumbData.url,
          level: 'grandchild'
        });
      }

      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(breadcrumbData));
        
        const event = new CustomEvent('breadcrumb:path-saved', {
          detail: breadcrumbData
        });
        document.dispatchEvent(event);
      } catch (error) {
        // Silently fail
      }
    }

    static getSavedBreadcrumb() {
      try {
        const saved = sessionStorage.getItem('breadcrumb_navigation_path');
        return saved ? JSON.parse(saved) : null;
      } catch (error) {
        return null;
      }
    }

    static clearSavedBreadcrumb() {
      try {
        sessionStorage.removeItem('breadcrumb_navigation_path');
      } catch (error) {
        // Silently fail
      }
    }
  }

  // Inicializar el tracker de breadcrumbs
  document.addEventListener('DOMContentLoaded', () => {
    window.breadcrumbTracker = new BreadcrumbTracker();
  });

  // Exponer métodos estáticos globalmente para uso en otros scripts
  window.BreadcrumbTracker = BreadcrumbTracker;

  } catch(e) { console.error(e); }
})();
})();
